import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import getAssistanceNumber from "src/utils/getAssistanceNumber";
import { useNavigate } from "react-router-dom";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

const RentalErrorMessageDialog = () => {
  const open = useSelector((state) => state.rental.errorAlert || false);
  const loginState = useSelector((state) => state.rental.login);
  const content = useSelector((state) => state.rental.errorMessage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const brand = getBrandFromUrl();

  const phoneNumber = getAssistanceNumber();
  const errorMessage =
    loginState === "failed"
      ? `${content}Please call us on ${phoneNumber} to make any changes.`
      : `${content}Please call us on ${phoneNumber} to discuss your options.`;

  const handleClose = () => {
    console.log("Closing dialog");
    dispatch({ type: "RENTAL_ERROR_ALERT_CLOSE" });
    navigate(`/rental/manage/login?brand=${brand}`, { replace: true });
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <span style={{ fontSize: "1.5rem", fontWeight: "bold" }}>Notice</span>
      </DialogTitle>
      <DialogContent>
        <p>{errorMessage}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RentalErrorMessageDialog;
